// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"67edf449","455":"146182d2"}[chunkId] + ".chunk.js";
};